import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../http.service';
import { NgStyle } from '@angular/common';
import * as CryptoJS from 'crypto-js';

// Declare Razorpay as a global variable
declare var Razorpay: any;

@Component({
  selector: 'app-razorpay-checkout',
  templateUrl: './razorpay-checkout.component.html',
  styleUrls: ['./razorpay-checkout.component.scss'],
})
export class RazorpayCheckoutComponent implements OnInit, OnDestroy {
  orderId: any;
  refNo: any;
  amount: any;
  bankName: any;
  payment_link_reference_id: any;
  payment_link_id: any;
  payment_status: any;
  razorpay_signature: any;
  razorpayid: any;
  message: any;
  channel: any;
  isBin: any;
  b64ReturnUrl: any;
  returnUrl: any;
  href: any;
  binSeries: any;
  dismissedOnce = false;
  displayload: boolean = false;
  razorpaykey: any;
  mobileNo: string = '';
  constructor(
    public http: HttpClient,
    private route: ActivatedRoute,
    private apiService: HttpService,
    private router: Router
  ) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  async ngOnInit() {
    this.href = this.router.url;
    console.log(this.href);
    this.insertLogs(this.href);
    this.apiService.setLocalStorage('PaymentType', 'razorpay');
    this.orderId = this.route.snapshot.queryParamMap.get('orderId');
    this.apiService.setLocalStorage('orderId', this.orderId);
    this.refNo = this.route.snapshot.queryParamMap.get('refNo');
    this.apiService.setLocalStorage('refNo', this.refNo);
    this.bankName = this.route.snapshot.queryParamMap.get('bankName');
    this.apiService.setLocalStorage('bankName', this.bankName);
    this.amount = this.route.snapshot.queryParamMap.get('amount');
    this.apiService.setLocalStorage('amount', this.amount);
    this.channel = this.route.snapshot.queryParamMap.get('channel');
    this.apiService.setLocalStorage('channel', this.channel);
    this.isBin = this.route.snapshot.queryParamMap.get('isBin');
    this.apiService.setLocalStorage('isBin', this.isBin);
    this.b64ReturnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.mobileNo = this.route.snapshot.queryParamMap.get('mobile') || '';
    const bins = this.route.snapshot.queryParamMap.get('bins');
    if (this.mobileNo)
      this.apiService.setLocalStorage('mobileNo', this.mobileNo);
    this.returnUrl = atob(this.b64ReturnUrl);
    this.apiService.setLocalStorage('returnUrl', this.returnUrl);
    console.log('isBin', this.isBin);

    if (this.isBin == 'true') {
      if (bins) {
        this.binSeries = JSON.parse(atob(bins));
      }else{
        this.binSeries = await this.GetBinSeries(this.bankName);
      }
    } else {
      this.binSeries = [];
    }
    console.log('binSeries', this.binSeries);
    await this.GetRazorPayKey();
    // console.log(location.origin);
    await this.startPayment();
  }
  startPayment() {
    this.dismissedOnce = false;
    const storedEmail = localStorage.getItem('emailId');
    const storedPhone = localStorage.getItem('mobileNo');
    const storedName = localStorage.getItem('name');
    const isMobile = this.isMobile();

    console.log('isMobile', isMobile);
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization: token,
      }),
    };

    const options: any = {
      key: this.razorpaykey,
      amount: this.amount,
      currency: 'INR',
      name: 'Cheggout services',
      description: 'Payment for order ' + this.orderId,
      order_id: this.orderId,
      webview_intent: true,    
      // callback_url: this.returnUrl +
      //       '?razorpay_payment_id=' +
      //       this.razorpayid +
      //       '&paymentType=razorpay&order_id=' +
      //       this.refNo,
      retry: {
        enabled: false, // 👈 Disables Razorpay retry page on failure
      },
      handler: (response: any) => {
        this.displayload = true;
        console.log('Payment Success:', response);
        this.apiService.setLocalStorage('Message', 'Payment Success');
        this.razorpayid = response.razorpay_payment_id;
        this.apiService.setLocalStorage('razorpayid', this.razorpayid);
        if (this.channel == 'CHEGGOUT') {
          this.router.navigate(['/success']);
        } else {
          this.displayload = false;
          if( this.channel.toLowerCase() === 'gcpwa'){
            const url =this.returnUrl +
            '&razorpay_payment_id=' +
            this.razorpayid +
            '&paymentType=razorpay&order_id=' +
            this.refNo+'&browserType=native';
            
            // const url =this.returnUrl +
            // '?razorpay_payment_id=' +
            // this.razorpayid +
            // '&paymentType=razorpay&order_id=' +
            // this.refNo;
                  
            this.insertLogs(url)

             window.location.href = url;
            if ((window as any)) {
                  
            (window as any).postMessage("payment_success",url);
            } else {
            this.insertLogs("fallback "+ url)
            window.location.href = url; // fallback for browser
            }
          }else if(this.channel.toLowerCase() === 'rupeestore' || this.channel.toLowerCase() === 'masterhotdeal'){
            const url =this.returnUrl +
            '?razorpay_payment_id=' +
            this.razorpayid +
            '&paymentType=razorpay&order_id=' +
            this.refNo;
            this.insertLogsAFTERPAYMENT('hotdeal '+this.channel.toLowerCase()+ ' ' +url)

            window.location.href = url;
            if ((window as any)) {
            (window as any).postMessage("payment_success",url);
            } else {
            window.location.href = url; // fallback for browser
            }
          }
            else{
              const url = this.returnUrl +
            '?razorpay_payment_id=' +
            this.razorpayid +
            '&paymentType=razorpay&order_id=' +
            this.refNo;
            this.insertLogsAFTERPAYMENT('other channel '+this.channel.toLowerCase()+ ' ' +url)

            window.location.href =
            this.returnUrl +
            '?razorpay_payment_id=' +
            this.razorpayid +
            '&paymentType=razorpay&order_id=' +
            this.refNo;
          
          
          // window.location.href =
          //   this.returnUrl +
          //   '?razorpay_payment_id=' +
          //   this.razorpayid +
          //   '&paymentType=razorpay&order_id=' +
          //   this.refNo;
        }
      }
    },
      modal: {
        ondismiss: async () => {
          this.displayload = true;
          // this.insertLogs('payment failed' + this.refNo);
          // this.insertLogs('payment failed channel' + this.channel);
          await this.apiService.UpdateTransactionFailurinInput(
            this.refNo,
            'failed'
          );
          this.apiService.setLocalStorage('Message', 'Payment Failed');

          if (this.channel == 'CHEGGOUT') {
            if (!this.dismissedOnce) {
              this.dismissedOnce = true; // Set flag
              this.router.navigate(['/payment-failure']);
              // window.location.href =
              //   this.returnUrl +
              //   '?payment_status=failed&paymentType=razorpay&order_id=' +
              //   this.refNo;
            }
          } else if(this.channel.toLowerCase() === 'rupeestore' || this.channel.toLowerCase() === 'masterhotdeal'){
            this.insertLogs(this.returnUrl +
              '?payment_status=failed&paymentType=razorpay&order_id=' +
              this.refNo)
            window.location.href =
              // this.returnUrl +
              // '?payment_status=failed&paymentType=razorpay&order_id=' +
              // this.refNo;
              this.returnUrl +
              '?payment_status=failed&paymentType=razorpay&order_id=' +
              this.refNo;
          }
          else {
            this.insertLogs(this.returnUrl +
              '?payment_status=failed&paymentType=razorpay&order_id=' +
              this.refNo)
            window.location.href =
              // this.returnUrl +
              // '?payment_status=failed&paymentType=razorpay&order_id=' +
              // this.refNo;
              this.returnUrl +
              '?payment_status=failed&paymentType=razorpay&order_id=' +
              this.refNo+'&browserType=native';
          }
        },
      },

      // prefill: {
      //   name: storedName ? storedName : 'Cheggout',
      //   email: storedEmail ? storedEmail : 'support@cheggout.com',
      //   contact: storedPhone ? storedPhone : '9886589260',
      // },
      // readonly: {
      //   name: true,
      //   email: true,
      //   contact: true,
      // },
      config: {
        display: {
          // customer: {
          //   name: 'Customer Details',
          //   hide: true,
          // },
          blocks: {
            banks:
              this.isBin === 'true'
                ? {
                    name: 'Card Payment Only',
                    instruments: [
                      {
                        method: 'card',
                        iins: this.binSeries, // Example: ['411111', '512345']
                      },
                    ],
                  }
                : isMobile
                ? {
                    name: 'All Payment Options',
                    instruments: [
                      { method: 'upi' },
                      { method: 'card' },
                      { method: 'netbanking' },
                    ],
                  }
                : {
                    name: 'All Payment Options',
                    instruments: [
                      { method: 'upi' },
                      { method: 'card' },
                      { method: 'netbanking' },
                    ],
                  },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false,
          },
        },
      },

      notes: {
        orderId: this.orderId,
        reference_id: this.refNo,
        amount: this.amount,
      },
      redirect: false
    };
    // if (
    //   this.channel.toLowerCase() === 'cheggout' ||
    //   this.channel.toLowerCase() === 'gcpwa'
    // ) {
    //   options.prefill = {
    //     name: 'Cheggout',
    //     email: 'support@cheggout.com',
    //     contact: '9886589260',
    //   };
    //   // options.prefill = {
    //   //   contact: storedPhone,
    //   // };
    // }
    if (
      this.channel.toLowerCase() === 'pnbtemple' ||
      this.channel.toLowerCase() === 'flight' ||
      this.channel.toLowerCase() === 'cheggout' ||
      this.channel.toLowerCase() === 'gcpwa'
    ) {
      // options.prefill = {
      //   name: 'Cheggout',
      //   email: 'support@cheggout.com',
      //   contact: '9886589260',
      // };
      options.prefill = {
        contact: storedPhone,
      };
    }
    console.log('Razorpay options:', JSON.stringify(options));
    this.insertLogs('Razorpay options:' + JSON.stringify(options));
    const rzp = new Razorpay(options);
    rzp.open();
  }

  async postPaymentDetails() {
    this.displayload = true;
    this.orderId = this.apiService.getLocalStorage('orderId');
    let model: any;
    model = {
      bankName: this.bankName,
      order_id: this.refNo,
      razorpay_payment_id: this.razorpayid,
      paymentType: 'razorpay',
    };

    let result = await this.apiService.postRazorPaymentDetails(model);

    if (result) {
      this.displayload = false;
      this.apiService.setLocalStorage('ChegUrl', result.chegUrl);
      this.insertLogs(
        'ChegUrl ' + result.chegUrl + 'Message ' + result.message
      );
      let status = result.status.toLowerCase();
      this.insertLogs(
        'ChegUrl ' +
          result.chegUrl +
          'Message ' +
          result.message +
          'status ' +
          status
      );
      if (status == 'complete') {
        this.router.navigate(['/success']);
        this.apiService.setLocalStorage('Message', result.message);
      } else if (status == 'payment failed') {
        this.apiService.setLocalStorage('Message', result.message);
        console.log('2', result);
        this.router.navigate(['/payment-failure']);
      } else if (status == 'payment progress') {
        this.message = result.message;
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/payment-pending']);
        // alert(result.message);//closable popup
      } else if (status == 'failed') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'invalid') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'invalid amount') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/failure']);
      } else if (status == 'processing') {
        this.apiService.setLocalStorage('Message', result.message);
        this.router.navigate(['/success']);
      }
    }
  }
  async insertLogs(url: any) {
    let data = {
      moduleName: 'razorpay checkout',
      url: url,
    };
    let result = await this.apiService.insertLogs(data);
  }
   async insertLogsAFTERPAYMENT(url: any) {
    let data = {
      moduleName: 'razorpay PAYMENT RETURN URL',
      url: url,
    };
    let result = await this.apiService.insertLogs(data);
  }
  async GetBinSeries(bankName: any) {
    let result = await this.apiService.GetBinSeries(bankName);
    return result;
  }
  async GetRazorPayKey() {
    let result = await this.apiService.GetRazorPayKey();
    let b64enckey = atob(result.result);
    const [beforeKey, afterKey] = b64enckey.split('#'); // Split the string
    console.log('Before Key:', beforeKey);
    console.log('After Key:', afterKey);
    this.razorpaykey = this.decryptPassword(beforeKey, afterKey);
  }
  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /android|iphone|ipad|iPod/i.test(userAgent.toLowerCase());
  }

  decryptPassword(cipherText: string, encryptionKey: string): string {
    // Salt used in your .NET code (same byte array)
    const salt = CryptoJS.enc.Hex.parse('4976616e204d65647665646576'); // Ivan Medvedev

    // Derive key and IV using PBKDF2
    const keySize = 256 / 32; // 32 bytes
    const ivSize = 128 / 32; // 16 bytes
    const keyAndIV = CryptoJS.PBKDF2(encryptionKey, salt, {
      keySize: keySize + ivSize,
      iterations: 1000, // Default in .NET unless otherwise specified
      hasher: CryptoJS.algo.SHA1,
    });

    const key = CryptoJS.lib.WordArray.create(keyAndIV.words.slice(0, keySize));
    const iv = CryptoJS.lib.WordArray.create(
      keyAndIV.words.slice(keySize, keySize + ivSize)
    );

    // Decode Base64 and decrypt
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // .NET uses UTF-16 (Unicode), convert accordingly
    const decryptedText = CryptoJS.enc.Utf16LE.stringify(decrypted);
    console.log('Decrypted Text:', decryptedText);
    return decryptedText;
  }

  ngOnDestroy() {
    console.log('RazorpayComponent DESTROYED');
  }
}
